import { all, takeEvery, select, put } from 'redux-saga/effects';
import { actions as reportsActions } from './reducer';
import { getFileName } from './selector';

export const saveData = (data, fileName) => {
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Let the browser start reading the download before releasing the URL.
  window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
};

export function* downloadFile({ payload }) {
  const fileName = yield select(getFileName);
  saveData(payload, fileName);
  yield put(reportsActions.clear());
}

export default function* () {
  yield all([takeEvery(reportsActions.fetch, downloadFile)]);
}
